// 配置全局访问接口地址
// let commonUrl = "//h5test.ag-lotre.com";
let commonUrl = typeof window !== "undefined" ? `${window.location.origin}/` : "/";
 
let baseUrl = {
    commonUrl
}
 
export default baseUrl
